export const STEPS = [
  {
    id: 1,
    number: "01",
    title: "Register & Verify",
    description:
      "Open your account quickly and securely. Our streamlined verification process gets you trading-ready in minutes, not days.",
  },
  {
    id: 2,
    number: "02",
    title: "Get Funded",
    description:
      "Deposit via your preferred method and instantly access your full trading environment with all instruments unlocked.",
  },
  {
    id: 3,
    number: "03",
    title: "Trade the Month",
    description:
      "Execute with precision using competitive ECN pricing and ultra-fast execution across MT4, MT5 and the GODO Mobile App.",
  },
  {
    id: 4,
    number: "04",
    title: "Win & Withdraw",
    description:
      "Climb the leaderboard, claim your share of the prize pool, and withdraw your rewards with ease.",
  },
];
